<template>
  <div id="UseCommunityInteractiveScreen">
    <div id="mokuai-count">
      <p class="title">各模块使用次数占比</p>
      <DomeEchartWrap ref="mokuai-pie" id="mokuai-pie"></DomeEchartWrap>
    </div>
    <div id="zt-mokuai-countA">
      <p class="title">专题版面模块使用次数排名</p>
      <DomeEchartWrap ref="zt-mokuai-count" id="zt-mokuai-count"></DomeEchartWrap>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
export default {
  name: 'UseCommunityInteractiveScreen',
  components: {
    DomeEchartWrap
  },
  props: [

  ],
  data () {
    return {
      echartZBarOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          triggerOn: 'click'
        },
        legend: {
          show: false
        },
        grid: {
          left: '10%',
          top: '0%',
          right: '10%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [{
          type: 'value',
          show: false,
          axisLabel: {
            formatter: '{value}'
          },
          axisLine: {
            show: false
          }
        }],
        yAxis: [
          {
            type: 'category',
            inverse: true,
            data: ['党的100岁生日', '红色电影', '三合一课', '党史检验', '新思想', '学组先锋'],
            show: true,
            axisLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: 'City Alpha',
            type: 'bar',
            data: [60292, 60197, 58299, 51782, 50829, 49202],
            label: {
              normal: {
                position: 'insideRight',
                show: true,
                textBorderColor: '#333',
                textBorderWidth: 2,
                color: 'rgba(255,255,255,1)',
                formatter: (val) => {
                  return `${val.data}次`
                }
              }
            },
            barWidth: 20,
            itemStyle: {
              normal: {
                // color: new echarts.graphic.LinearGradient(1, 0, 0, 1, [{ offset: 0, color: '#01C7E5' }, { offset: 1, color: '#042CF3' }])
                color: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#01C7E5' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#042CF3' // 100% 处的颜色
                  }]
                }
              }
            }
          }
        ]
      },
      echartPieOptions: {
        color: ['#00D7E9', '#0088FF', '#C80FCB', '#9400D5', '#5F15F0', '#042CF3'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          left: 10,
          data: ['学组先锋', '组织介绍', '智慧南山', '会议系统', '影视娱乐', '少儿教育'],
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['35%', '50%'],
            top: 30,
            label: {

              formatter: (val) => {
                return `{n|${val.name}}\n{l|————}\n{c|${val.percent}%}`
              },
              // formatter: [
              //   '{a|这段文本采用样式a}',
              //   '{b|这段文本采用样式b}这段用默认样式{x|这段用样式x}'
              // ].join('\n'),
              distanceToLabelLine: 0,
              rich: {
                c: {
                  color: '#fff'
                },
                x: {
                  fontSize: 18,
                  fontFamily: 'Microsoft YaHei',
                  borderColor: '#449933',
                  borderRadius: 4
                }
              }
            },
            data: [
              { value: '55', name: '学组先锋' },
              { value: '19', name: '组织介绍' },
              { value: '13', name: '智慧南山' },
              { value: '5', name: '会议系统' },
              { value: '5', name: '影视娱乐' },
              { value: '3', name: '少儿教育' }
            ]
          }
        ]
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.$refs['mokuai-pie'].setEchartOption(this.echartPieOptions)
    this.$refs['zt-mokuai-count'].setEchartOption(this.echartZBarOptions)
  },
  watch: {

  },
  methods: {

  }
}
</script>

<style scoped lang="stylus">
#UseCommunityInteractiveScreen
  padding-top: 1rem
  height 14.7rem
  display: flex
  box-sizing border-box
  #mokuai-count,#zt-mokuai-countA
    flex-basis: 50%
    .title
      font-size: .9rem
      color: #fff
      text-align center
      margin-bottom: .5rem
</style>
